export default "__VITE_ASSET__sLVUX2k34Tp3hZhWBSKPlg__";